export default "__VITE_ASSET__188224b7__"